import { render } from "./TheSheetsDialog.vue?vue&type=template&id=16d45085&ts=true"
import script from "./TheSheetsDialog.vue?vue&type=script&lang=ts"
export * from "./TheSheetsDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__